import employeeProfile from '@/api/human-resource/employee-profile';

import { baseState, baseMutations } from '@/store/mixins';
import { isEmpty } from 'lodash';

export const state = {
    ...baseState,
    formViewDatas: []
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_FORMVIEWDATA(state, data) {
        state.formViewDatas = data;
    }
}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attrubutes
        )
        return employeeProfile.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    store(context, data) {
        return employeeProfile.store(data)
    },
    async find(context, id) {
        if (isEmpty(context.state.edit_data)) {
            let response = await employeeProfile.find(id)
            context.commit('SET_EDIT_DATA', response.data)
        }
    },
    update(context, { id, data }) {
        return employeeProfile.update(id, data)
    },
    destroy(context, id) {
        return employeeProfile.destroy(id)
    },
    async getFormViewData(context) {
        let response = await employeeProfile.formModel();
        context.commit("SET_FORMVIEWDATA", response.data);
    },
    photoUpload(context, data) {
        return employeeProfile.photoUpload(data)
    }
}
